import React from 'react';
import {Spinner} from 'reactstrap';
import PropTypes from 'prop-types';

class MagstimLoadingSpinner extends React.Component {

    render() {

		var loadingSpinner;

		if(this.props.isLoading){
			loadingSpinner = <div className="text-center mt-4 mb-4"><Spinner type="grow" variant="primary"/> </div>
        }
        
        return  <>{loadingSpinner}</>
    }
}

MagstimLoadingSpinner.propTypes = {
    isLoading: PropTypes.bool,
};

MagstimLoadingSpinner.defaultProps = {
    isLoading: false
}


export default MagstimLoadingSpinner;